import TeamSerialNumber from "../TeamSerialNumber";

const LeagueTeamName = ({
  teamNumber,
  teamName,
  isOpponentTeam = false,
  showSerialNumber = true,
}) => {
  return (
    <div
      className={`si-league__teamName ${
        isOpponentTeam ? "si-league__teamName--opponent" : ""
      }`}
    >
      {showSerialNumber && (
        <TeamSerialNumber teamNumber={teamNumber} isInactive={isOpponentTeam} />
      )}
      <span className="si-league__teamName-text">{teamName}</span>
    </div>
  );
};

export default LeagueTeamName;
